import { DetailsPanel } from '@/components/controls';
import { useOptionLookup } from '@/hooks';
import { Box, Stack, Typography } from '@mui/material';
import { cyan } from '@mui/material/colors';
import { format } from 'date-fns';
import { Popup } from 'react-map-gl/maplibre';
import { Status } from './Status';

export function ExternalPersonPopup({
  hoverInfo: {
    longitude,
    latitude,
    feature: { properties },
  },
}) {
  const personRoles = useOptionLookup('personRole');

  return (
    <Popup
      longitude={longitude}
      latitude={latitude}
      offset={16}
      closeButton={false}
    >
      <Stack spacing={0.5}>
        <Stack
          direction="row"
          spacing={1}
          sx={{ alignItems: 'center', justifyContent: 'space-between' }}
        >
          <Typography variant="subtitle1" sx={{ fontWeight: 'bold' }}>
            {properties.code}
          </Typography>
          {properties.assignments?.callSign && (
            <Box
              sx={{
                fontSize: 10,
                color: 'white',
                bgcolor: cyan[900],
                borderRadius: 1,
                px: 0.5,
              }}
            >
              {properties.assignments.callSign.code}
            </Box>
          )}
        </Stack>
        <Typography variant="caption" color="textSecondary">
          {format(new Date(properties.time), 'dd/MM HH:mm:ss')}
        </Typography>
        <Status status={properties.status} />
        <DetailsPanel
          entries={[
            { label: 'External Person' },
            {
              label: 'Rank',
              value: properties.category,
            },
            {
              label: 'Role',
              value: personRoles[properties.role] ?? properties.role,
            },
          ]}
        />
      </Stack>
    </Popup>
  );
}
